import React from 'react';
import { Form, Grid } from 'semantic-ui-react';

import { NombrePersonal } from 'src/api/protocolo/comunes';
import Campo from './Campo';

interface InfoPlanesDePagoProps {
    idPlanDePago: string;
    estado: string;
    formaDePago: string;
    numeroDePagare?: number;
    valorDelPagare?: number;
    fechaPrimeraCuota: string;
    diaDePago?: number;
    numeroDeCuotas: number;
    valorPorCuota: number;
    sumaDeLosContratos: number;
    fechaDeMatricula: string;
    observacionesFinancieras: string;
    aNombreDeAsesor:
        | {
              id: string;
              nombre: NombrePersonal;
          }
        | undefined;
    sede: 'alameda' | 'san-fernando' | 'uchile';
}

function escribirFormaDepago(forma: string) {
    if (forma === 'contado') {
        return 'contado';
    }
    if (forma === 'tarjeta') {
        return 'tarjeta';
    }
    if (forma === 'pagare') {
        return 'pagaré';
    }
    if (forma === 'cheque') {
        return 'cheque';
    }
    throw new Error('No se pudo determinar la forma de pago');
}

function escribirFecha(fecha: string) {
    const [año, mes, dia] = fecha.split('-');
    return `${dia}-${mes}-${año}`;
}

function escribirMonto(monto: number) {
    const valorConPuntos = monto.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return '$' + valorConPuntos;
}

const InfoPlanesDePago: React.FunctionComponent<InfoPlanesDePagoProps> = props => {
    const {
        formaDePago,
        numeroDePagare,
        valorDelPagare,
        numeroDeCuotas,
        valorPorCuota,
        sumaDeLosContratos,
        fechaDeMatricula,
        observacionesFinancieras,
        aNombreDeAsesor,
        sede,
    } = props;
    return (
        <div>
            <Grid columns='2'>
                <Grid.Column>
                    <Grid.Row>
                        <Campo etiqueta='Forma de pago' valor={escribirFormaDepago(formaDePago)} />
                        <Campo
                            etiqueta='Numero de pagaré'
                            valor={numeroDePagare}
                            ocultar={numeroDePagare === undefined}
                        />
                        <Campo
                            etiqueta='Fecha de matricula'
                            valor={escribirFecha(fechaDeMatricula)}
                        />
                        <Campo
                            etiqueta='Asesor'
                            valor={
                                aNombreDeAsesor
                                    ? [
                                          aNombreDeAsesor.nombre.primerNombre,
                                          aNombreDeAsesor.nombre.apellidoPaterno,
                                          aNombreDeAsesor.nombre.apellidoMaterno.charAt(0),
                                          '.',
                                      ].join(' ')
                                    : '<asesor no encontrado>'
                            }
                        />
                        <Campo
                            etiqueta='Sede'
                            valor={
                                {
                                    'alameda': 'Alameda',
                                    'san-fernando': 'San Fernando',
                                    'uchile': 'U. de Chile',
                                }[sede]
                            }
                        />
                    </Grid.Row>
                </Grid.Column>
                <Grid.Column>
                    <Grid.Row>
                        <Campo
                            etiqueta='Suma de los contratos'
                            valor={escribirMonto(sumaDeLosContratos)}
                        />
                        <Campo
                            etiqueta='Valor del pagaré'
                            valor={escribirMonto(valorDelPagare || 0)}
                            ocultar={valorDelPagare === undefined}
                        />
                        <Campo etiqueta='Número de cuotas' valor={numeroDeCuotas.toString()} />
                        <Campo etiqueta='Valor por cuota' valor={escribirMonto(valorPorCuota)} />
                    </Grid.Row>
                </Grid.Column>
            </Grid>

            {observacionesFinancieras && (
                <Form>
                    <Form.TextArea
                        label='Observaciones financieras ingresadas por el asesor comercial'
                        value={observacionesFinancieras}
                        readOnly
                    />
                </Form>
            )}
        </div>
    );
};

export default InfoPlanesDePago;



// WEBPACK FOOTER //
// ./src/modulos/Cobranzas/componentes/FichaDeApoderado/InfoPlanesDePago.tsx